/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_InstructionsInputs */

const en_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click on the secure login link in the email to access your account.`)
};

const id_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik tautan login aman di email untuk mengakses akun Anda.`)
};

const ms_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik pada pautan log masuk selamat dalam emel untuk mengakses akaun anda.`)
};

const ca_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fes clic en l'enllaç segur de sessió al correu per accedir al teu compte.`)
};

const cs_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikněte na bezpečný odkaz pro přihlášení v emailu pro přístup k vašemu účtu.`)
};

const da_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik på det sikre login-link i e-mailen for at få adgang til din konto.`)
};

const de_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf den sicheren Anmeldelink in der E-Mail, um auf Ihr Konto zuzugreifen.`)
};

const et_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klõpsake e-kirjas oleval turvalisel sisselogimislingil, et pääseda oma kontole.`)
};

const es_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic en el enlace seguro de inicio de sesión en el correo electrónico para acceder a tu cuenta.`)
};

const fr_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur le lien de connexion sécurisé dans l’e-mail pour accéder à votre compte.`)
};

const hr_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknite na sigurnu vezu za prijavu u e-mailu kako biste pristupili svom računu.`)
};

const it_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai clic sul link di accesso sicuro nell'email per accedere al tuo account.`)
};

const lv_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noklikšķiniet uz drošās pieslēgšanās saites e-pastā, lai piekļūtu savam kontam.`)
};

const lt_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustelėkite saugaus prisijungimo nuorodą el. laiške, kad pasiektumėte savo paskyrą.`)
};

const hu_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kattintson a biztonságos bejelentkezési linkre az e-mailben a fiókjához való hozzáféréshez.`)
};

const nl_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik op de beveiligde inloglink in de e-mail om toegang te krijgen tot je account.`)
};

const nb_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikk på innloggingslenken i e-posten for å logge på kontoen din.`)
};

const pl_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknij bezpieczny link do zalogowania w e-mailu, aby uzyskać dostęp do swojego konta.`)
};

const pt_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique no link de login seguro no e-mail para acessar sua conta.`)
};

const ro_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faceți clic pe linkul sigur de autentificare din e-mail pentru a accesa contul dvs.`)
};

const sk_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknite na bezpečný odkaz v e-maile a získate prístup k svojmu účtu.`)
};

const sl_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknite na varno povezavo za prijavo v e-pošti za dostop do vašega računa.`)
};

const fi_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikkaa sähköpostin suojattua kirjautumislinkkiä päästäksesi tilillesi.`)
};

const sv_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicka på den säkra inloggningslänken i mailet för att komma åt ditt konto.`)
};

const vi_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhấp vào liên kết đăng nhập bảo mật trong email để truy cập tài khoản của bạn.`)
};

const tr_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınıza erişmek için e-postadaki güvenli oturum açma bağlantısına tıklayın.`)
};

const el_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάντε κλικ στον ασφαλή σύνδεσμο στο email για να αποκτήσετε πρόσβαση στον λογαριασμό σας.`)
};

const bg_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кликнете върху защитената връзка за вход в имейла, за да получите достъп до вашия акаунт.`)
};

const ru_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите на безопасную ссылку для входа в письме, чтобы получить доступ к своему аккаунту.`)
};

const sr_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кликните на сигурну везу за пријаву у емаилу да бисте приступили свом налогу.`)
};

const uk_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Натисніть на захищене посилання для входу в листі, щоб отримати доступ до вашого облікового запису.`)
};

const ka_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დააწკაპუნეთ უსაფრთხო შესვლის ბმულზე მეილში, რომ ანგარიშს წვდომა მიიღოთ.`)
};

const hi_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने खाते तक पहुंचने के लिए ईमेल में सुरक्षित लॉगिन लिंक पर क्लिक करें।`)
};

const th_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลิกที่ลิงก์เข้าสู่ระบบที่ปลอดภัยในอีเมลเพื่อเข้าถึงบัญชีของคุณ`)
};

const ko_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정에 접근하려면 이메일의 안전한 로그인 링크를 클릭하십시오.`)
};

const zh_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请点击电子邮件中的安全登录链接以访问您的账户。`)
};

const zh_tw_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請點擊電子郵件中的安全登入連結以存取您的帳戶。`)
};

const ja_login_email_instructions = /** @type {(inputs: Login_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールに記載されているセキュアログインリンクをクリックして、アカウントにアクセスしてください。`)
};

/**
* | output |
* | --- |
* | "Click on the secure login link in the email to access your account." |
*
* @param {Login_Email_InstructionsInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const login_email_instructions = /** @type {((inputs?: Login_Email_InstructionsInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_InstructionsInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_login_email_instructions(inputs)
	if (locale === "ms") return ms_login_email_instructions(inputs)
	if (locale === "ca") return ca_login_email_instructions(inputs)
	if (locale === "cs") return cs_login_email_instructions(inputs)
	if (locale === "da") return da_login_email_instructions(inputs)
	if (locale === "de") return de_login_email_instructions(inputs)
	if (locale === "et") return et_login_email_instructions(inputs)
	if (locale === "es") return es_login_email_instructions(inputs)
	if (locale === "fr") return fr_login_email_instructions(inputs)
	if (locale === "hr") return hr_login_email_instructions(inputs)
	if (locale === "it") return it_login_email_instructions(inputs)
	if (locale === "lv") return lv_login_email_instructions(inputs)
	if (locale === "lt") return lt_login_email_instructions(inputs)
	if (locale === "hu") return hu_login_email_instructions(inputs)
	if (locale === "nl") return nl_login_email_instructions(inputs)
	if (locale === "nb") return nb_login_email_instructions(inputs)
	if (locale === "pl") return pl_login_email_instructions(inputs)
	if (locale === "pt") return pt_login_email_instructions(inputs)
	if (locale === "ro") return ro_login_email_instructions(inputs)
	if (locale === "sk") return sk_login_email_instructions(inputs)
	if (locale === "sl") return sl_login_email_instructions(inputs)
	if (locale === "fi") return fi_login_email_instructions(inputs)
	if (locale === "sv") return sv_login_email_instructions(inputs)
	if (locale === "vi") return vi_login_email_instructions(inputs)
	if (locale === "tr") return tr_login_email_instructions(inputs)
	if (locale === "el") return el_login_email_instructions(inputs)
	if (locale === "bg") return bg_login_email_instructions(inputs)
	if (locale === "ru") return ru_login_email_instructions(inputs)
	if (locale === "sr") return sr_login_email_instructions(inputs)
	if (locale === "uk") return uk_login_email_instructions(inputs)
	if (locale === "ka") return ka_login_email_instructions(inputs)
	if (locale === "hi") return hi_login_email_instructions(inputs)
	if (locale === "th") return th_login_email_instructions(inputs)
	if (locale === "ko") return ko_login_email_instructions(inputs)
	if (locale === "zh") return zh_login_email_instructions(inputs)
	if (locale === "zh-tw") return zh_tw_login_email_instructions(inputs)
	if (locale === "ja") return ja_login_email_instructions(inputs)
	return en_login_email_instructions(inputs)
});